import { openBlock as c, createElementBlock as t, createElementVNode as e } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, n = /* @__PURE__ */ e("path", { d: "M9.4 18.91c0-.66-.54-1.2-1.2-1.2-.66 0-1.2.54-1.2 1.2 0 .66.54 1.2 1.2 1.2.66 0 1.2-.54 1.2-1.2Zm-1.2-8.136c.66 0 1.2.54 1.2 1.2 0 .66-.54 1.2-1.2 1.2-.66 0-1.2-.54-1.2-1.2 0-.66.54-1.2 1.2-1.2ZM8.2 4c.66 0 1.2.54 1.2 1.2 0 .66-.54 1.2-1.2 1.2-.66 0-1.2-.54-1.2-1.2C7 4.54 7.54 4 8.2 4Z" }, null, -1), d = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "M5.61 22.727h12.78c.877 0 1.598-.721 1.598-1.598V16.5H20V15h-.012V9.112H20v-1.5h-.012V2.87c0-.876-.721-1.597-1.597-1.597H5.609c-.876 0-1.597.721-1.597 1.597v4.742H4v1.5h.012V15H4v1.5h.012v4.63c0 .876.72 1.597 1.597 1.597Zm13.009-1.598V16.5H5.38v4.63c0 .127.1.228.228.228H18.39c.127 0 .228-.1.228-.229ZM5.38 15h13.238V9.112H5.38V15Zm0-7.388h13.238V2.87c0-.127-.1-.228-.228-.228H5.609c-.128 0-.228.1-.228.228v4.742Z",
  "clip-rule": "evenodd"
}, null, -1), h = [
  n,
  d
];
function l(r, s) {
  return c(), t("svg", o, [...h]);
}
const a = { render: l };
export {
  a as default,
  l as render
};
